import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteData, getData, imgUrl, postData } from '../Services/api';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Pagination from '../Services/Pagination';

const CustomerList = () => {
    const [limit, setLimit] = useState(10);
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [selectedCustomers, setSelectedCustomers] = useState([]);


    const [exporting, setExporting] = useState(false);




    // Select single customer
        const handleSelectCustomer = (id) => {
            setSelectedCustomers((prev) =>
                prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
            );
        };

        // Select all customers on current page
        const handleSelectAll = () => {
            if (selectedCustomers.length === users.length) {
                setSelectedCustomers([]);
            } else {
                setSelectedCustomers(users.map((u) => u.id));
            }
        };


        const handleBulkDelete = () => {
    if (selectedCustomers.length === 0) {
        toast.warn('Please select at least one customer!');
        return;
    }

    Swal.fire({
        title: 'Delete selected customers?',
        text: 'This will permanently remove selected customers!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete all!',
    }).then(async (result) => {
        if (result.isConfirmed) {
            try {
                const res = await postData(`/customers/delete-multiple`, { ids: selectedCustomers });

                if (res.success) {
                    toast.success(res.message);
                    setSelectedCustomers([]);
                    fetchUsers();
                }
            } catch (error) {
                console.log('Bulk delete error', error);
                toast.error('Failed to delete selected customers');
            }
        }
    });
};




const handleExport = async () => {
  try {
    setExporting(true); // 🔥 start loader

    const query = new URLSearchParams({
      search,
      routeId: '',
      createdByUserId: ''
    }).toString();

    const res = await fetch(
      `${imgUrl}/api/v1/customers/export-excel?${query}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    if (!res.ok) throw new Error('Failed to export');

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `customers_${Date.now()}.xlsx`;
    link.click();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
    toast.error('Failed to export customers');
  } finally {
    setExporting(false); // 🔥 stop loader
  }
};


    // Fetch users
    const fetchUsers = async (pageNumber = page, searchQuery = search) => {
        try {
            const res = await getData(`/customers/all?page=${pageNumber}&search=${searchQuery}`);
            if (res.success) {
                setUsers(res.data || []);
                setPage(res.pagination.page || 1);
                setPages(res.pagination.pages || 0);
                setTotal(res.pagination.total || 1);
                setLimit(res.pagination.limit || 10);
            }
        } catch (error) {
            console.log("Error fetching users:", error);
        }
    };

    // Debounce search
    useEffect(() => {
        const timer = setTimeout(() => fetchUsers(1, search), 500);
        return () => clearTimeout(timer);
    }, [search]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) fetchUsers(pageNumber);
    };

    const handleDelete = (userId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/customers/delete/${userId}`);
                    toast.success(res.message);
                    fetchUsers();
                } catch (error) {
                    console.log("Error deleting user:", error);
                    toast.error("Delete failed");
                }
            }
        });
    };

    const handleFileChange = (e) => setFile(e.target.files[0]);

    const handleUpload = async () => {
        if (!file) return toast.error("Please select a file");

        const formData = new FormData();
        formData.append('file', file);
        setUploading(true);

        try {
            const res = await postData(`${imgUrl}/api/v1/customers/import-excel`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (res.success) {
                toast.success('Excel uploaded successfully');
                fetchUsers();
            } else {
                toast.error(res.message || 'Upload failed');
            }
        } catch (err) {
            console.error(err);
            toast.error('Server error');
        } finally {
            setUploading(false);
        }
    };

    // Download demo file
    const handleDownloadDemo = () => {
        // Assuming demo file is stored in public folder or served via backend
        const demoFileUrl = `${imgUrl}/uploads/demo/customer-demo.xlsx`;
        const link = document.createElement('a');
        link.href = demoFileUrl;
        link.download = 'customer-demo.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/users/customer-list">Customers</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Customers
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0">Customers</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="card table-card">
                            <div className="card-body">
                                <div className="text-end p-4 pb-sm-2">
                                    <Link
                                        to="/customer/customer-create"
                                        className="btn btn-primary d-inline-flex align-item-center"
                                    >
                                        <i className="fas fa-plus f-18 mx-2" /> Add Customer
                                    </Link>


                                    <button onClick={handleBulkDelete} className="btn btn-danger mx-2">
                                    <i className="fas fa-trash mx-1" /> Delete Selected
                                    </button>

                                </div>
                                <div className="d-sm-flex align-items-center p-4">
                                    <ul className="list-inline me-auto my-1">
                                        <li className="list-inline-item">
                                            <div className="form-search">
                                                <i className="fas fa-search" />
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    placeholder="Search user"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="d-flex align-items-center gap-2">
                                        <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
                                        <button className="btn btn-success" onClick={handleUpload} disabled={uploading}>
                                            {uploading ? 'Uploading...' : 'Upload Excel'}
                                        </button>
                                        <button onClick={handleDownloadDemo} className="btn btn-secondary">
                                            Download Demo File
                                        </button>



                                        <button
                                            onClick={handleExport}
                                            className="btn btn-success"
                                            disabled={exporting}
                                            >
                                            {exporting ? (
                                                <>
                                                <span className="spinner-border spinner-border-sm me-2" />
                                                Exporting...
                                                </>
                                            ) : (
                                                'Export Customers'
                                            )}
                                        </button>


                                    </div> 

                                </div>

                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    onChange={handleSelectAll}
                                                    checked={users.length > 0 && selectedCustomers.length === users.length}
                                                />
                                            </th>
                                                <th>S.No.</th>
                                                <th>Customer Name</th>
                                                <th>Customer Type</th>
                                                <th>Sales Person name</th>
                                                <th>Address</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.length > 0 ? (
                                                users.map((user, index) => (
                                                    <tr key={user.id}>
                                                    <td>
        <input
            type="checkbox"
            checked={selectedCustomers.includes(user.id)}
            onChange={() => handleSelectCustomer(user.id)}
        />
    </td>
                                                        <td>{index + 1 + (page - 1) * limit}</td>
                                                        <td>{user.name}</td>
                                                        <td>{user.customer_type}</td>
                                                        <td>{user.createdBy?.username}</td>
                                                        <td>{user.address}</td>
                                                        <td className="text-center">
                                                            <ul className="list-inline me-auto mb-0">
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" title="View">
                                                                    <Link
                                                                        to={`/customer/view-customer/${user.id}`}
                                                                        className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                    >
                                                                        <i className="fas fa-eye f-18" />
                                                                    </Link>
                                                                </li>
                                                                    <li
                                                                        className="list-inline-item align-bottom"
                                                                        data-bs-toggle="tooltip"
                                                                        title="Edit"
                                                                    >
                                                                        <Link
                                                                            to={`/customer/customer-update/${user.id}`}
                                                                            className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                        >
                                                                            <i className="fas fa-edit f-18" />
                                                                        </Link>
                                                                    </li>
                                                                <li
                                                                    onClick={() => handleDelete(user.id)}
                                                                    className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                >
                                                                    <i className="fas fa-trash f-18" />
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="text-center" colSpan={6}>
                                                        <strong>No Users Found.</strong>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                    <div className="text-muted">
                                        Showing {(page - 1) * limit + 1} to {Math.min(page * limit, total)} of {total} entries
                                    </div>
                                    <Pagination page={page} pages={pages} onPageChange={handlePageChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerList;
